import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  spaceId: number;
  id: string;
  name?: string;
  notes?: string;
  displayOrder?: number;
};

const [useUpdateMarket, updateMarket] = createAsyncAction(
  "markets/update",
  async ({ spaceId, id, name, notes, displayOrder }: Args) => {
    const res = await API.call<{ market: string }>({
      endpoint: `spaces/${spaceId}/markets/${id}`,
      method: "PUT",
      data: {
        name,
        notes,
        display_order: displayOrder,
      },
    });
    return { ...res, result: res.result.market };
  }
);

export default useUpdateMarket;
export { updateMarket };
